import { Component, EventEmitter, Output, Input, TemplateRef, ViewChild, ViewContainerRef, inject, OnInit, AfterViewInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { FormType, FormTypeValue } from '../../../core/constants/form-type.constants';
import { TrainingComponent } from '../../customer/training/training.component';
import { HealthfairComponent } from '../../customer/healthfair/healthfair.component';
import {EventLogReferrerConstants} from '../../../core/constants/event-log-referrer.constants';

export interface SidePanelConfig {
  formType?: FormTypeValue;
  title?: string;
  contentTemplate?: TemplateRef<any>;
  referrer?: EventLogReferrerConstants;
}

@Component({
  selector: 'app-side-panel',
  standalone: true,
  imports: [CommonModule, TrainingComponent, HealthfairComponent],
  templateUrl: './side-panel.component.html',
  styleUrl: './side-panel.component.css',
  animations: [
    trigger('slideIn', [
      state('void', style({ transform: 'translateX(100%)' })),
      state('*', style({ transform: 'translateX(0)' })),
      transition('void => *', [
        animate('300ms ease-out')
      ]),
      transition('* => void', [
        animate('300ms ease-in')
      ])
    ]),
    trigger('fadeIn', [
      state('false', style({ opacity: 0, visibility: 'hidden' })),
      state('true', style({ opacity: 1, visibility: 'visible' })),
      transition('false => true', [
        animate('250ms ease-out')
      ]),
      transition('true => false', [
        animate('200ms ease-in')
      ])
    ])
  ]
})
export class SidePanelComponent implements OnInit, AfterViewInit {
  @Output() closeEvent = new EventEmitter<void>();
  @Output() reloadEvents = new EventEmitter<void>();
  @Input() title: string = '';
  @Input() formType: FormTypeValue = null;
  @Input() contentTemplate: TemplateRef<any> | null = null;
  @Input() referrer: EventLogReferrerConstants;

  readonly FormType = FormType;
  contentReady: boolean = false;
  contentVisible: boolean = false;

  ngOnInit(): void {
    // Render content immediately so it's in the DOM and positioned
    // This prevents layout shift when content appears
    this.contentReady = true;
  }

  ngAfterViewInit(): void {
    // Delay content visibility to coordinate with slide animation
    // This prevents flicker by ensuring panel is positioned before content fades in
    setTimeout(() => {
      this.contentVisible = true;
    }, 150);
  }

  close(): void {
    this.closeEvent.emit();
  }

  handleFormSubmit(data: any) {
    console.log('Form submitted:', data);
    // Handle form submission
    this.close();
  }

  protected readonly EventLogReferrerConstants = EventLogReferrerConstants;
}
